import Box from 'components_new/atoms/Box'
import React, { ReactNode } from 'react'

import type { DraggableSyntheticListeners } from '@dnd-kit/core'

import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'

export interface DndListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  disabled?: boolean
  editable: boolean
  handleDelete?: () => void
  listeners?: DraggableSyntheticListeners
  sx?: object
  variant?: 'filled' | 'outlined' | 'transparent'
}

const DndListItem = React.forwardRef((props: DndListItemProps, ref: any) => {
  const {
    children,
    disabled,
    editable,
    handleDelete,
    listeners,
    sx,
    variant,
    ...rest
  } = props

  return (
    <Box
      component="li"
      {...rest}
      ref={ref}
      sx={{
        alignItems: 'stretch',
        bgcolor: disabled
          ? 'background.overlay'
          : variant === 'filled'
            ? 'background.paper'
            : undefined,
        border: variant === 'outlined' ? '1px solid' : undefined,
        borderColor: 'divider',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        opacity: disabled ? 0.5 : undefined,
        pointerEvents: disabled ? 'none' : undefined,
        ...sx
      }}
    >
      {editable ? (
        <Box
          {...listeners}
          sx={{
            alignItems: 'center',
            borderRadius: 1,
            cursor: disabled ? 'not-allowed' : 'grab',
            display: 'flex',
            width: 24,
            '&:hover': !disabled
              ? {
                  bgcolor: 'action.hover'
                }
              : undefined
          }}
        >
          <Icon color="disabled" name="DragHandleVertical" />
        </Box>
      ) : null}
      <Box sx={{ flex: 1, minWidth: 0, position: 'relative' }}>{children}</Box>
      {editable && handleDelete ? (
        <Box sx={{ alignItems: 'center', display: 'flex', mr: 0.5 }}>
          <IconButton onClick={handleDelete} size="small">
            <Icon fontSize="small" name="RemoveCircleOutlineOutlined" />
          </IconButton>
        </Box>
      ) : null}
    </Box>
  )
})

DndListItem.displayName = 'DndListItem'
export default DndListItem
